import * as React from 'react';
import classNames from 'classnames';
import { assign as _assign } from 'lodash';
import { ConfigurationModel, AssemblyAccessoriesModel, AssemblyAccessoriesDefaultModel } from 'franke-trough-dependencies';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { UncontrolledTooltip } from 'reactstrap';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Assemblies.messages';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface AssemblySelectionProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
}

export interface AssemblySelectionState {
  selection?: boolean;
}

export class AssemblySelectionPartial extends React.Component<AssemblySelectionProps, AssemblySelectionState> {
  constructor(props: AssemblySelectionProps) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (!this.selection) {
      return;
    }

    this.setState({
      selection: this.selection,
    });
  }

  componentDidUpdate(prevProps: AssemblySelectionProps) {
    const prevConfiguration = prevProps.configuration.result;

    if (
      (this.configuration && prevConfiguration) && 
      (this.configuration.updated_at !== prevConfiguration.updated_at)  
    ) {
      if (!this.selection) { return; }
      this.setState({
        selection: this.selection,
      });
    }
  }

  public render() {
    const value = this.state.selection || this.selection || (this.selection && this.selectionDefaults && this.selectionDefaults.default) || false;
    const disabled = !isConfigurationEditable();

    return (
      <div className="partial-assembly-selection position-relative pb-4">
        <div className="col-12">
          <label className={classNames({disabled: disabled})}>
            <FormattedMessage {...MESSAGES.withAssemblyAccessories} />
            <input
              className={disabled ? 'disabled' : ''}
              name="selection" 
              type="radio"
              value={'true'}
              checked={value === true}
              onChange={this.handleChange}
              disabled={disabled}
            />
            <span className="checkmark" />
          </label>
        </div>
        <div className="col-12">
          <label className={classNames({disabled: disabled})}>
            <FormattedMessage {...MESSAGES.withoutAssemblyAccessories} />
            <input
              className={disabled ? 'disabled' : ''}
              name="selection" 
              type="radio"
              value={'false'}
              checked={value === false}
              onChange={this.handleChange}
              disabled={disabled}
            />
            <span className="checkmark" />
          </label>
        </div>
      </div>
    );
  }
  
  private dispatchConfiguration(selection: boolean) {
    if (!this.assemblyAccessories) { return; }

    const assemblyAccessories: AssemblyAccessoriesModel = this.assemblyAccessories as AssemblyAccessoriesModel;
    const data: AssemblyAccessoriesModel = _assign({}, assemblyAccessories, {
      selection,
      console: selection === false ? null : assemblyAccessories.console,
    });
    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {assemblyAccessories: data}
        },
      },
      true,
    ));
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    if (!isConfigurationEditable()) { return; }

    const target = event.target as HTMLInputElement;
    let selection: boolean = false;
    if (target.value === 'true') {
      selection = true;
    } else if (target.value === 'false') {
      selection = false;
    }
    this.setState({
      selection
    });
    this.dispatchConfiguration(selection);
  }

  private get assemblyAccessories(): AssemblyAccessoriesModel | undefined {
    return this.configuration && this.configuration.assemblyAccessories;
  }

  private get configuration(): ConfigurationModel | undefined{
    return this.props.configuration && this.props.configuration.result;
  }

  private get selection(): AssemblyAccessoriesModel['selection'] | undefined {
    return this.assemblyAccessories && this.assemblyAccessories.selection;
  }

  private get selectionDefaults(): AssemblyAccessoriesDefaultModel['selection'] | undefined {
    return this.configuration && this.configuration.defaults.assemblyAccessories.selection;
  }
  
  private get trough() { 
    return this.props.configuration.result && this.props.configuration.result.selectedTrough && this.props.configuration.result.selectedTrough.trough;
  }
}

export const AssemblySelection = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(AssemblySelectionPartial);

export default AssemblySelection;
